/*
 * File: index.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 3, 2025 at 12:13 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 1, 2025 at 11:28 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Utilities
import { api } from '../api';

// Constants
const { PARSE_MOUNT } = process.env;


/**
 * Services
 */

export const recordAction = ({
	action,
	urlPath,
	context
} = {}) => api.post(`${PARSE_MOUNT}/functions/recordActionWithParameters`, {
	id: action,
	url_path: urlPath,
	context
});

export const recordPlatformMovement = ({
	path,
	query,
	hash,
	referrer,
	sessionEnd
} = {}) => api.post('/_api/movement/track', {
	path,
	query,
	hash,
	referrer,
	sessionEnd
});
